<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('head')">
      <h2 :class="b('head-title')">{{ $t("Параметры обмена") }}</h2>
      <span :class="b('live')">
        <span :class="b('live-dot')"></span>
        {{ $t("Курс live") }}
      </span>
    </div>

    <div :class="b('fields')">
      <div :class="b('scores')">
        <ApplicationFormScore
          :class="b('score', { from: true })"
          :title="$t('Со счета')"
          :options="displayedFromOptions"
          :value="displayedApplicationStoreRequest.currency_id_from"
          @update:value="handleCurrencyIdFrom"
          @create="handleCryptoCreate"
        >
          <template #header-extra>
            <div :class="b('limits')">
              <UIButton v-if="pair" label="МИН" view="max" @click="handleMin" />
              <UIButton label="МАКС" view="max" @click="handleMax" />
            </div>
          </template>

          <template #amount>
            <SharedCurrency
              :label="displayedCurrencyName.toUpperCase()"
              :value="
                currencyTypeAmountFormatter(
                  displayedApplicationStoreRequest.currency_type_from,
                  displayedApplicationStoreRequest.amount
                )
              "
              :max-value="
                currencyTypeAmountFormatter(
                  displayedApplicationStoreRequest.currency_type_from,
                  displayedApplicationStoreRequest.max_amount
                )
              "
              :is-number="true"
              :is-max-value="true"
              :is-error="isErrorAmount"
              @update:value="handleAmount"
            />
          </template>

          <template #footer>
            <p :class="b('available')">
              {{ $t("Доступно") }}
              <b>
                {{
                  currencyTypeAmountFormatter(
                    displayedApplicationStoreRequest.currency_type_from,
                    displayedApplicationStoreRequest.max_amount
                  )
                }}
                {{ displayedCurrencyName.toUpperCase() }}
              </b>
            </p>

            <SharedSelect
              v-if="isRequisitesFromShow"
              :class="b('requisites')"
              view="light"
              :placeholder="$t('Выберите реквизиты')"
              :options="displayedRequisitesFromOptions"
              v-model:value="
                displayedApplicationStoreRequest.user_requisite_id_from
              "
            />
          </template>
        </ApplicationFormScore>

        <div :class="b('divider')">
          <span></span>
          <button
            type="button"
            :class="b('swap')"
            :disabled="!displayedApplicationStoreRequest.currency_id_to"
            aria-label="Поменять счета местами"
            @click="handleSwap"
          >
            <svg
              :class="b('swap-icon', { rotating: isSwapAnimating })"
              viewBox="0 0 24 24"
              aria-hidden="true"
              @animationend="handleSwapAnimationEnd"
            >
              <path d="M9 5v14m0-14L6 8m3-3 3 3M15 19V5m0 14 3-3m-3 3-3-3" />
            </svg>
          </button>
          <span></span>
        </div>

        <ApplicationFormScore
          :class="b('score', { to: true })"
          :title="$t('На счет')"
          :options="displayedToOptions"
          :value="displayedApplicationStoreRequest.currency_id_to"
          @update:value="handleCurrencyIdTo"
          @create="handleCryptoCreate"
        >
          <template #amount>
            <p :class="b('receive-preview')">
              {{ isCommissionsShow ? displayedAmount : "0,00" }}
            </p>
          </template>

          <template #footer>
            <SharedSelect
              v-if="isRequisitesToShow"
              :class="b('requisites')"
              view="light"
              :placeholder="$t('Выберите реквизиты')"
              :options="displayedRequisitesToOptions"
              v-model:value="
                displayedApplicationStoreRequest.user_requisite_id_to
              "
            />

            <div v-if="pair" :class="b('pair-info')">
              <span>{{ pair.status }}</span>
              <span>{{ $t("Мин:") }} {{ pair.min }} {{ pair.baseCoin }}</span>
            </div>
          </template>
        </ApplicationFormScore>
      </div>

      <div
        v-if="
          isRateLoading || displayedApplicationStoreRequest.execution_price > 0
        "
        :class="b('rate')"
      >
        <p :class="b('rate-title')">
          <span></span>
          {{ $t("Текущий курс") }}
        </p>
        <div
          v-if="isRateLoading"
          :class="b('rate-skeleton')"
          aria-hidden="true"
        >
          <span></span>
          <span></span>
        </div>
        <div v-else :class="b('rate-values')">
          <p>
            1 {{ displayedCurrencyName.toUpperCase() }} =
            <b>{{ displayedCourse }}</b>
            {{
              displayedCurrencyTo?.currency?.name.toUpperCase() ||
              displayedCurrencyTo?.name.toUpperCase()
            }}
          </p>
          <p>
            1
            {{
              displayedCurrencyTo?.currency?.name.toUpperCase() ||
              displayedCurrencyTo?.name.toUpperCase()
            }}
            = <b>{{ displayedCourseInverse }}</b>
            {{ displayedCurrencyName.toUpperCase() }}
          </p>
        </div>
      </div>

      <div :class="b('summary')">
        <p :class="b('summary-label')">{{ $t("Вы получите") }}</p>
        <p :class="b('summary-value')">
          {{ isCommissionsShow ? displayedAmount : "0,00" }}
          <span>
            {{
              displayedCurrencyTo?.currency?.name.toUpperCase() ||
              displayedCurrencyTo?.name.toUpperCase() ||
              ""
            }}
          </span>
        </p>
        <p v-if="isCommissionsShow" :class="b('commission')">
          {{ $t("Комиссия") }}: ~ {{ displayedCommission }}
          {{ displayedCurrencyName.toUpperCase() }}
        </p>
      </div>

      <p
        v-if="
          displayedApplicationStoreRequest.currency_type_from === 'fiat' &&
          displayedApplicationStoreRequest.currency_type_to === 'fiat' &&
          displayedApplicationStoreRequest.amount >
            displayedApplicationStoreRequest.max_amount
        "
        :class="b('message-error')"
      >
        {{ $t("Не хватает средств") }}
      </p>
    </div>

    <UIButton
      v-tooltip="
        notVerified
          ? $t('Для получения доступа пройдите процедуру верификации')
          : null
      "
      view="main"
      :disabled="isNextDisabled"
      @click="handleNext"
    >
      <span>{{ $t("Далее") }}</span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 12h13m-5-5 5 5-5 5" />
      </svg>
    </UIButton>
  </div>
</template>
